import { NewsItem } from '@aipb/gulliver/catalog/model';

import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { TranslocoModule } from '@jsverse/transloco';
import { NewsItemComponent } from '../news-item/news-item.component';

@Component({
  selector: 'cat-news-list',
  templateUrl: './news-list.component.html',
  styleUrls: ['./news-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TranslocoModule, NewsItemComponent, MatDividerModule]
})
export class NewsListComponent {
  @Input() items: NewsItem[] = [];
}
